import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ClientProcessingError } from 'app/_errors/client-processing.error';
import { UnknownApplicationError } from 'app/_errors/unknown-application.error';
import { throwError } from 'rxjs';

@Injectable()
export class SiteOwnerUserService {

  constructor(private http: HttpClient) { }


  // Get All Site Owner w/no pagination and no disabled, sorted by name
  public getAllEnabledSiteOwnersForDropdowns() {
    return this.http.get(environment.apiUrl + 'api/ext-skylark-user/site-owner-user?excludeDisabled=true&size=10000000&page=0')
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Get All Site Owners w/pagination
  public getAllSiteOwners(pagination, sort) {

    let paginationString = '';
    paginationString += '?size=' + pagination.size;
    paginationString += '&page=' + pagination.page;

    const sortString = '&sort=' + sort;

    return this.http.get(environment.apiUrl + 'api/ext-skylark-user/site-owner-user' + paginationString + sortString, { observe: 'response' })
      .pipe(map(this.handleDataWithHeaders))
      .pipe(catchError(this.handleError));
  }

  public createSiteOwner(obj) {
    return this.http.post(environment.apiUrl + 'api/ext-skylark-user/site-owner-user-create', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }


  public getSiteOwnerById(skylarkUserId) {
    return this.http.get(environment.apiUrl + `api/ext-skylark-user/${skylarkUserId}`)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public editSiteOwner(obj) {
    return this.http.put(environment.apiUrl + 'api/ext-skylark-user/site-owner-user-update', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  public updateSiteOwnerPassword(obj) {
    return this.http.put(environment.apiUrl + 'api/ext-skylark-user/update-password', obj)
      .pipe(map(this.handleData))
      .pipe(catchError(this.handleError));
  }

  // Handle Responses
  private handleData(res: HttpResponse<any>) {
    const body = res;
    return body;
  }

  public handleDataWithHeaders(res: HttpResponse<any>) {
    const headers = res.headers;
    const body = res.body;
    const data = {
      'headers': headers,
      'body': body
    };
    return data;
  }


  private handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      return throwError(error);
    }

    if (error instanceof Error) {
      return throwError(
        new ClientProcessingError('The application could not process the server response.', error)
      );
    }

    return throwError(
      new UnknownApplicationError('The application threw an unknown error value.', error)
    );
  }

}
